import { apiRequest } from './helpers';
import { buildUrl } from '../lib/route.utils';
import { ALL_PAGESIZE } from '../constants/admin/settings';
import { CONTRACT_TYPES } from '../constants/settings';
import { omit } from 'lodash';

export const events = {
    get: () => apiRequest('GET', `/events?pagesize=${ALL_PAGESIZE}`, {}),
    getTimetable: id => apiRequest('GET', `/events/${id}/timetable`, {}),
    getNotifications: id => apiRequest('GET', `/events/${id}/notifications`, {}),
    getPartners: eventId => apiRequest('GET', `/partners?eventId=${eventId}&pagesize=${ALL_PAGESIZE}`, {})
};

export const users = {
    login: (email, password) => apiRequest('POST', '/login ', { skipToken: true, body: { email, password } }),
    profile: () => apiRequest('GET', '/users/me', {}),
    acceptTos: () => apiRequest('PUT', '/users/me', { body: { tosAndPrivacy: true } }),
    setNotificationsSeen: () =>
        apiRequest('PUT', '/users/me', { body: { notificationsSeenAt: new Date().toISOString() } }),
    setFavorites: favs => apiRequest('PUT', '/users/me', { body: { favoriteArtists: favs } }),
    setPreferences: preferences => apiRequest('PUT', '/users/me', { body: { preferences } }),
    changePassword: (id, user) => apiRequest('PUT', `/users/${id}/passwords`, { body: user }),
    reset: email => apiRequest('POST', '/users/reset ', { skipToken: true, body: { email } })
};

export const contracts = {
    getInbox: (pagination, type = CONTRACT_TYPES.CLEARANCE) => {
        return apiRequest(
            'GET',
            buildUrl('/contracts/inbox?', { page: pagination.page, resultsPerPage: pagination.pageSize, type: type }),
            {}
        );
    },
    get: id => apiRequest('GET', `/contracts/inbox/${id}`),
    getPublic: (id, pinCode) => apiRequest('GET', `/contracts/public/${id}${pinCode ? `?pin=${pinCode}` : ''} `),
    getPublicOnlyType: (id) => apiRequest('GET', `/contracts/public/${id}?onlyType=true`),
    downloadUpload: (id, version) => apiRequest('GET', `/contracts/${id}/downloads/${version}?upload=true`),
    download: (id, version) => apiRequest('GET', `/contracts/${id}/downloads/${version}`),
    downloadPublic: (id, version) => apiRequest('GET', `/contracts/${id}/public-downloads/${version}`),
    put: (id, body) => apiRequest('PUT', `/contracts/${id}`, { body: omit(body, 'type') }),
    postVersion: (id, body) => apiRequest('POST', `/contracts/${id}/versions`, { body }),
    postPublic: (id, body) => apiRequest('POST', `/contracts/${id}/public`, { body })
};



// WEBPACK FOOTER //
// ./src/services/api.js